import StockProductListDetailsTable from "./components/StockProductListDetailsTable";

export default function StockProductListDetails() {
  return (
    <div className="container-96 pt-10">
      <StockProductListDetailsTable />
    </div>
  );
}
